<template>
	<div class="team">
		<Bannerinner/>
		<div class="titleinfo">
			<h3><a href="/">首页</a><em>></em><router-link :to="{path:'/team/index.html'}">冠领团队</router-link><em>></em>{{lmname}}</h3>
			<h2 class="linebox">
				<strong>冠领团队</strong>
				<em></em>
				<p>精诚团结&nbsp;&nbsp;&nbsp;&nbsp;超古冠今</p>
			</h2>
		</div>
		<div class="teamwrap">
			<div class="teambtn">
				<span @click="changeIndex(index,item.lmid)" :class="index == currentIndex ? 'active' : ' '"  v-for="item,index in navList" :key="item.id">{{item.name}}</span>
			</div>
			
			<div class="teambox" >
				<div class="zhuren teamitem">
					<h3>主任律师</h3>
					<ul>
						<li v-for="item,index in zrData" :key="item.id" >
							<router-link class="zhureninner" :to="{path:'/team/v/'+item.id+'.html'}">
							<div class="zrimg">
								<img :src="item.thumb" alt="">
								<strong>{{item.title}}</strong>
							</div>
							<div class="zrinfo">
								<div class="zrinfobox">
									<p>{{item.description}}...<em>详情></em></p>
								</div>
							</div>
						</router-link></li>

					</ul>
				</div>
				
				<div class="teamitem" v-if="show">
					<h3 class="changetitle">{{lmname}}</h3>
					<ol>
						<li v-for="item,index in cqData" :key="item.id">
							<router-link class="iteminner" :to="{path:'/team/v/'+item.id+'.html'}">
							<img :src="item.thumb" alt="">
							<p>{{item.title}}</p>
						</router-link></li>
					</ol>
					<div class="page">
					 <el-pagination
					   background
						hide-on-single-page
					   :current-page.sync='currentpage'
					   @current-change="getPage"
					   layout="prev, pager, next"
					   prev-text="上一页"
					   next-text="下一页"
					   :page-size="pagesize"
					   :pager-count = pagerCount
					   :total="total">
					 </el-pagination>
					</div>
				</div>



			</div>
		</div>

	</div>
</template>


<script>
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import Bannerinner from '@/components/Bannerinner'
	import { title } from '../global/common.js'
	export default{
		name:'Team',
		components:{
			Bannerinner
		},
		data(){
			return{
				lmname:'',
				show:false,
				currentIndex:99,
				zrData:[],
				cqData:[],
				gwData:[],
				sxData:[],
				zlData:[],
				comData:[],
				pageData:[],
				total:0,
				currentpage:1,
				pagerCount:5,
				isshow:false,
				itempage:false,
				id:0,
				pagesize:9,
				origin:'',
				zhixing:0,
				lmid:0,
				pagetitle:'法律顾问',
				size:9,
				navList:[
					{id:0,name:'主任律师',lmid:13},
					{id:1,name:'法律顾问',lmid:31},
					{id:2,name:'拆迁律师',lmid:14},
					{id:3,name:'实习律师',lmid:15},
					{id:4,name:'律师助理',lmid:16}
				]
			}
		},
		methods:{
			getData(lmid,pagesize){
				let that = this
				if(lmid == 13){
					that.zrData = []
				}else {
					that.cqData = []
				}
				
				request({
					url: '/team/read?catid='+lmid+'&pgae=1&page_size='+pagesize,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
								
								if(lmid == 13){
									that.zrData.push(value)
								}else {
		
									that.cqData.push(value)
									that.total = beforeData['total']
								}
								// that.comData.push(value)
							})
							
						}
					}]
				})
			},
			getPage(val){
				let that = this
				that.cqData = []

				request({
					url: '/team/read?catid='+that.lmid+'&page='+val+'&page_size='+that.size,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
								
								that.cqData.push(value)
								

								// that.comData.push(value)
							})
							that.total = beforeData['total']
							
						}
					}]
				})
			},
			changeIndex(index,lmid){
				this.currentIndex = index
				this.lmid = lmid
				this.lmname = this.navList[index].name
				if(index != 0){
					this.getData(lmid,9)
					this.show = true
				}else{
					this.show = false
				}
				// this.$router.push({
				// 	path:'/team/list/'+index+'.html'
				// })

			},
			initData(){
				this.getData(13,2)//主任
				let from = this.$route.params.from
				this.currentIndex = from
				this.lmname = this.navList[from].name
				let lmid = this.navList[from].lmid
				this.lmid = lmid
				if(from != 0){
					this.getData(lmid,9)
					this.show = true
				}else{
					this.show = false
				}
				document.title = '冠领律师-'+title
				
			}
		},
		created() {
			this.initData()
			
			
		},
		watch:{
			$route(to,from){
				this.initData()
			}
		}
	}
</script>

<style lang="scss" scoped>
.teamwrap{
    background: #fff;
    padding: 0 .3rem;
    overflow: hidden;
    margin-top: .15rem;
    .teambtn{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: .3rem;
        span{
            font-size: .26rem;
            padding: .1rem .25rem;
            white-space: nowrap;
            border: 1px solid #eeeeee;
            margin-bottom: .2rem;
            color: #9b9494;
            transition: all .2s linear;
        }
        span.active{
            background-color: #c21a20;
            color: #fff;
        }
    }
    .teambox{
        .teamitem:last-child{
            border: none;
            padding-bottom: .2rem;
            margin-bottom: .1rem;
        }
        .teamitem{
            border-bottom: 1px solid #ececec;
            margin-bottom: .4rem;
            padding-bottom: .3rem;
            h3{
                position: relative;
                font-size: .32rem;
                color: #fff;
                height: .65rem;
                text-align: center;
                line-height: .65rem;
                margin-left: .25rem;
                margin-bottom: .3rem;
                width: 3.2rem;
                background: linear-gradient(to bottom, #dc4f49 5%, #c21a20 45%,#c21a20 55%, #dc4f49 100%);
            }
            h3::after{
                content: "";
                position: absolute;
                left: -.25rem;
                top: 0;
                width: .06rem;
                height: .65rem;
                background-color: #c21a20;
            }
            ol{
                display: flex;
                flex-wrap: wrap;
                justify-content: start;
                li{
                    width: 2.1rem;
                    border: none;
					height: 2.99rem;
                    padding: 0;
                    margin-bottom: .3rem;
					box-shadow: 0 0 .03rem #ccc;
					position: relative;
                    .iteminner{
						display: block;
						width: 100%;
						height: 2.99rem;
                        img{

                        }
                        p{
                            text-align: center;
                            background: #c21a20;
                            color: #fff;
                            height: .4rem;
                            line-height: .4rem;
                            font-size: .26rem;
							position: absolute;
							bottom: 0;
							width: 100%;
                        }
                    }
                }
                li:nth-child(3n+2){
                    margin: 0 .3rem;
                }
            }
        }
        .zhuren{
            padding-bottom: .1rem;
            h3{
                width: 2.25rem;
            }
            ul{
                
                li{
                    margin-bottom: .2rem;
                    .zhureninner{
                        display: flex;
                        .zrimg{
                            width: 2.5rem;
                            margin-right: .2rem;
                            img{
                                width: 2.5rem;
                                height: 3.07rem;
                            }
                            strong{
                                display: block;
                                text-align: center;
                                background: #c21a20;
                                color: #fff;
                                height: .4rem;
                                line-height: .4rem;
                                font-size: .26rem;
                            }
                        }
                        .zrinfo{
                            width: 5rem;
                            font-size: .26rem;
							
							.zrinfobox{
								display: flex;
								flex-wrap: wrap;
							}
                            p{
                                line-height: .4rem;
								// text-overflow: ellipsis;
								// display: -webkit-box;
								// -webkit-box-orient: vertical;
								// -webkit-line-clamp: 7;
								// overflow: hidden;
								// position: relative;
								em{
								    color: #e61e1e;
								    font-weight: bold;
									display: inline-block;
									padding-left: .1rem;
								} 
                            }
							
                        }
                    }
                }
            }
        }
    }
}
.myform{
    border-top: none !important;
}
</style>